import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const [isSticky, setIsSticky] = useState(false);

  const closeMenu = () => setIsOpen(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleSubMenu = (menu) =>
    setActiveSubMenu(activeSubMenu === menu ? "" : menu);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* --- CSS Styles --- */}
      <style>
        {`
          /* DRAWER & BACKDROP (Unchanged) */
          .mobile-drawer {
            position: fixed; top: 0; right: 0; width: 280px; height: 100vh;
            background: #fff; z-index: 999999; transform: translateX(100%);
            transition: transform 0.3s ease-in-out; box-shadow: -5px 0 15px rgba(0,0,0,0.1);
            overflow-y: auto; display: flex; flex-direction: column;
          }
          .mobile-drawer.open { transform: translateX(0); }
          
          .mobile-backdrop {
            position: fixed; top: 0; left: 0; width: 100%; height: 100%;
            background: rgba(0,0,0,0.6); z-index: 999998; display: none;
          }
          .mobile-backdrop.open { display: block; }

          /* CLOSE BUTTON */
          .mobile-close-btn {
            position: absolute; top: 20px; right: 20px; width: 40px; height: 40px;
            background-color: #f1f1f1; color: #333; border-radius: 50%;
            display: flex; align-items: center; justify-content: center;
            font-size: 20px; font-weight: bold; cursor: pointer; z-index: 1000000;
          }

          /* --- HAMBURGER MENU FIX --- */
          .mr_mobile-nav-toggler {
            display: none;
            cursor: pointer;
            background: transparent;
            border: none;
            padding: 5px;
          }
          
          .mr_mobile-nav-toggler.hidden-btn {
            opacity: 0;
            pointer-events: none;
          }

          @media (max-width: 991px) {
            .mr_mobile-nav-toggler {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              width: 45px;
              height: 45px;
            }
            
            /* FORCE SPACE using Margins instead of Gap 
               (Foolproof method) 
            */
            .mr_mobile-nav-toggler span {
              display: block;
              width: 32px;  /* Width of the bars */
              height: 4px;  /* Thickness of the bars */
              background-color: #000;
              border-radius: 4px;
              margin-bottom: 7px; /* VERTICAL SPACE HERE */
            }

            /* Remove margin from the last bar so it stays centered */
            .mr_mobile-nav-toggler span:last-child {
              margin-bottom: 0;
            }

            .mr_main-menu { display: none !important; }
          }
          
          /* LINK STYLES */
          .mobile-nav-list { list-style: none; padding: 0 20px; margin-top: 80px; }
          .mobile-nav-list li { border-bottom: 1px solid #eee; }
          .mobile-nav-list a { display: block; padding: 15px 0; color: #333; font-weight: 600; text-decoration: none; }
          .mobile-submenu { display: none; background: #fafafa; padding-left: 15px; }
          .mobile-submenu.active { display: block; }
          .mobile-submenu a { font-weight: 400; font-size: 14px; padding: 12px 0; }
          .submenu-toggle { float: right; font-size: 20px; line-height: 50px; cursor: pointer; width: 40px; text-align: center; }
        `}
      </style>

      {/* --- MOBILE DRAWER --- */}
      <div
        className={`mobile-backdrop ${isOpen ? "open" : ""}`}
        onClick={closeMenu}
      ></div>

      <div className={`mobile-drawer ${isOpen ? "open" : ""}`}>
        <div className="mobile-close-btn" onClick={closeMenu}>
          ✕
        </div>
        <div style={{ position: "absolute", top: "20px", left: "20px" }}>
          <img
            src={`${process.env.PUBLIC_URL}/logo 1.png`}
            alt="Logo"
            style={{ width: "100px" }}
          />
        </div>

        <ul className="mobile-nav-list">
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu}>
              About Us
            </Link>
          </li>

          <li>
            <div style={{ overflow: "hidden" }}>
              <Link
                to="#"
                style={{ float: "left" }}
                onClick={(e) => e.preventDefault()}
              >
                Services
              </Link>
              <span
                className="submenu-toggle"
                onClick={() => toggleSubMenu("services")}
              >
                {activeSubMenu === "services" ? "−" : "+"}
              </span>
            </div>
            <ul
              className={`mobile-submenu ${
                activeSubMenu === "services" ? "active" : ""
              }`}
            >
              <li>
                <Link to="/solid-waste-management" onClick={closeMenu}>
                  Solid Waste Management
                </Link>
              </li>
              <li>
                <Link to="/bio-medical-waste-management" onClick={closeMenu}>
                  Bio Medical Waste
                </Link>
              </li>
              <li>
                <Link to="/hazardous-waste-management" onClick={closeMenu}>
                  Hazardous Waste
                </Link>
              </li>
              <li>
                <Link to="/faecal-sludge-waste-management" onClick={closeMenu}>
                  Faecal Sludge
                </Link>
              </li>
              <li>
                <Link to="/manpower-services-and-staffing" onClick={closeMenu}>
                  Manpower & Staffing
                </Link>
              </li>
              <li>
                <Link to="/construction" onClick={closeMenu}>
                  Construction
                </Link>
              </li>
               <li>
                <Link to="/liquid-waste-management" onClick={closeMenu}>
                  Liquid Waste Management
                </Link>
              </li>
               <li>
                <Link to="/construction" onClick={closeMenu}>
                  Security Services
                </Link>
              </li>
               <li>
                <Link to="/construction" onClick={closeMenu}>
                  Conservancy Services
                </Link>
              </li>
               <li>
                <Link to="/construction" onClick={closeMenu}>
                  Facility Management
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/products" onClick={closeMenu}>
              Products
            </Link>
          </li>
          <li>
            <Link to="/team" onClick={closeMenu}>
              Our Team
            </Link>
          </li>
          <li>
            <Link to="/career" onClick={closeMenu}>
              Career
            </Link>
          </li>

          <li>
            <div style={{ overflow: "hidden" }}>
              <Link
                to="#"
                style={{ float: "left" }}
                onClick={(e) => e.preventDefault()}
              >
                Media
              </Link>
              <span
                className="submenu-toggle"
                onClick={() => toggleSubMenu("media")}
              >
                {activeSubMenu === "media" ? "−" : "+"}
              </span>
            </div>
            <ul
              className={`mobile-submenu ${
                activeSubMenu === "media" ? "active" : ""
              }`}
            >
              <li>
                <Link to="/photos-and-videos" onClick={closeMenu}>
                  Photos & Videos
                </Link>
              </li>
              <li>
                <Link to="/blog" onClick={closeMenu}>
                  Blog
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/contact-us" onClick={closeMenu}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>

      {/* --- DESKTOP HEADER --- */}
      <div
        data-elementor-type="wp-post"
        data-elementor-id={2173}
        className="elementor elementor-2173"
      >
        {/* Top Bar */}
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-0fa3939 elementor-section-full_width wastix_header_section_01 elementor-hidden-tablet elementor-hidden-mobile elementor-section-height-default elementor-section-height-default"
          data-id="0fa3939"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-a7378fb wastix_header_datetime_01">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-d576cd8 wastix_info_list_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list">
                  <div className="elementor-widget-container">
                    <ul className="elementor-icon-list-items">
                      <li className="elementor-icon-list-item">
                        <span className="elementor-icon-list-icon">
                          <i aria-hidden="true" className=" icon-1" />
                        </span>
                        <span className="elementor-icon-list-text">
                          <span>Open Hours: </span> Mon-Fri 8:00 am-6:00 pm
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-45f7ac2 wastix_header_email_01">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-03652dc wastix_info_list_01 test_section_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list">
                  <div className="elementor-widget-container">
                    <ul className="elementor-icon-list-items">
                      <li className="elementor-icon-list-item">
                        <span className="elementor-icon-list-icon">
                          <i aria-hidden="true" className=" icon-2" />
                        </span>
                        <span className="elementor-icon-list-text">
                          <span>Email: </span> info@gcenvironment.com
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-7035192 wastix_header_address_01">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-74222cc wastix_info_list_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list">
                  <div className="elementor-widget-container">
                    <ul className="elementor-icon-list-items">
                      <li className="elementor-icon-list-item">
                        <span className="elementor-icon-list-icon">
                          <i aria-hidden="true" className=" icon-3" />
                        </span>
                        <span className="elementor-icon-list-text">
                          <span>Address: </span>Industrial
                          Estate,Rasulgarh-751010
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-37b2c3a wastix_header_login_01">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-76dae12 elementor-align-right elementor-mobile-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list">
                  <div className="elementor-widget-container">
                    <ul className="elementor-icon-list-items">
                      <li className="elementor-icon-list-item">
                        <span className="elementor-icon-list-text"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-92fab5b wastix_header_social_profile_01">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-bd47b52 e-grid-align-tablet-left e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons">
                  <div className="elementor-widget-container">
                    <div className="elementor-social-icons-wrapper elementor-grid">
                      {/* Facebook */}
                      <span className="elementor-grid-item">
                        <a
                          href="https://www.facebook.com/Greencirclebbsr/"
                          className="elementor-icon elementor-social-icon elementor-social-icon-facebook-f"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </span>

                      {/* Instagram */}
                      <span className="elementor-grid-item">
                        <a
                          href="https://www.instagram.com/greencircle.gcepl.123/"
                          className="elementor-icon elementor-social-icon elementor-social-icon-twitter"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </span>

                      {/* LinkedIn */}
                      <span className="elementor-grid-item">
                        <a
                          href="https://www.linkedin.com/company/green-circle-environment/?viewAsMember=true"
                          className="elementor-icon elementor-social-icon elementor-social-icon-linkedin-in"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Header */}
        <section
          className={`elementor-section elementor-top-section elementor-element elementor-element-b2b7844 elementor-section-full_width elementor-section-content-space-between elementor-section-height-default elementor-section-height-default ${
            isSticky ? "sticky-header" : ""
          }`}
          data-id="b2b7844"
          data-element_type="section"
        >
          <div
            className="elementor-container elementor-column-gap-no"
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* Logo */}
            <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-ef3859a">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-85cba7b elementor-widget elementor-widget-image">
                  <div className="elementor-widget-container">
                    <Link to="/">
                      <img
                        src={`${process.env.PUBLIC_URL}/logo 1.png`}
                        className="attachment-large size-large wp-image-1487  lg"
                        alt="Logo"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Menu */}
            <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a2d2d19 wastix_header_menu_01">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-222a12c elementor-widget__width-auto wastix_menu_01 elementor-widget elementor-widget-wpsection_wps_menu">
                  <div className="elementor-widget-container">
                    <header className="wps_header_area mr_main-header">
                      <div className="mr_header-lower">
                        <div className="mr_outer-container">
                          <div className="mr_outer-box">
                            <div className="mr_menu-area clearfix order-2">
                              {/* HAMBURGER BUTTON */}
                              <button
                                className={`mr_mobile-nav-toggler ${
                                  isOpen ? "hidden-btn" : ""
                                }`}
                                onClick={toggleMenu}
                              >
                                <span></span>
                                <span></span>
                                <span></span>
                              </button>

                              <nav className="mr_main-menu navbar-expand-md navbar-light">
                                <div className="collapse navbar-collapse show clearfix">
                                  <ul className="mr_navigation clearfix home-menu">
                                    <li className="menu-item">
                                      <Link to="/">Home</Link>
                                    </li>
                                    <li className="menu-item">
                                      <Link to="/about">About Us</Link>
                                    </li>
                                    <li className="menu-item dropdown">
                                      <Link to="#">Services</Link>
                                      <ul className="submenu">
                                        <li>
                                          <Link to="/solid-waste-management">
                                            Solid Waste Management
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/bio-medical-waste-management">
                                            Bio Medical Waste
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/hazardous-waste-management">
                                            Hazardous waste
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/faecal-sludge-waste-management">
                                            faecal-sludge
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/manpower-services-and-staffing">
                                            Manpower Services
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/construction">
                                            Construction
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/liquid-waste-management">
                                            Liquid Waste Management
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/facilitymanagement">
                                           Facility Management
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/securityservices">
                                           Security Services
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/conservancyservices">
                                           Conservency Services
                                          </Link>
                                        </li>
                                      </ul>
                                    </li>
                                    <li className="menu-item">
                                      <Link to="/products">Products</Link>
                                    </li>
                                    <li className="menu-item">
                                      <Link to="/team">Our Team</Link>
                                    </li>
                                    <li className="menu-item">
                                      <Link to="/career">Career</Link>
                                    </li>
                                    <li className="menu-item dropdown">
                                      <Link to="#">Media</Link>
                                      <ul className="submenu">
                                        <li>
                                          <Link to="/photos-and-videos">
                                            Photos
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to="/blog">Blog</Link>
                                        </li>
                                      </ul>
                                    </li>
                                    <li className="menu-item">
                                      <Link to="/contact-us">Contact Us</Link>
                                    </li>
                                  </ul>
                                </div>
                              </nav>
                            </div>
                          </div>
                        </div>
                      </div>
                    </header>
                  </div>
                </div>
              </div>
            </div>

            {/* Button */}
            <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-58e6d0f elementor-hidden-tablet elementor-hidden-mobile">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-f159951 wastix_btn_01 elementor-align-right elementor-widget elementor-widget-button">
                  <div className="elementor-widget-container">
                    <div className="elementor-button-wrapper">
                      
                      <Link
                        className="elementor-button elementor-button-link elementor-size-sm"
                        to="/contact-us"
                      >
                        <span className="elementor-button-text">
                          Request A Pickup
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Header;
